(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/match-view-list.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/match-view-list.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.MatchViewMatchList = Backbone.Marionette.CollectionView.extend(
    {
      tagName: 'div',
      className: 'swipe-wrap js-slider-wrapper slider-wrapper tabs-overflow-x',
      childView: svs.tipset.views.MatchViewListItem,

      collectionEvents: {
        currentMatchChanged: 'updateMatchSwiper'
      },

      updateMatchSwiper: function() {
        var currentMatch = this.collection.getCurrentMatch().get('eventNumber');

        this.slider.scrollTo(currentMatch - 1, true);
      },

      onAttach: function() {
        this.addMatchSwiper();
        this.updateMatchSwiper();
      },

      addMatchSwiper: function() {
        if (!this.slider) {
          var scrollist = $('#scrollist');

          this.children.each(function(child) {
            child.$el.css('width', 100);
          });

          this.slider = new svs.components.Slider(scrollist, {
            center: true,
            slideOnClick: true,
            slideOnDrag: false,
            solidNav: true
          });

          var backButton = $(
            '<div class="js-slider-slide slider-slide tabs-fixed-first-tab"><i class="icon-default icon-100 icon-menu-left fc-white"></i></div>'
          );
          backButton.click(function() {
            svs.obj.router.navigate('/' + location.search, {
              trigger: true,
              replace: false
            });
          });

          scrollist.prepend(backButton);

          this.slider.on('change', function(tab) {
            var currentTab = $('[data-index=' + (tab.index + 1) + ']');
            var e = $.Event('setMatch');
            currentTab.trigger(e);
          });
        }
      }
    }
  );
})(Backbone, _, svs);

 })(window);